import { RouteObject } from 'react-router-dom';
import GetReady from './pages/get-ready/GetReady';

const IntroRoutes: RouteObject = {
    path: 'intro',
    element: <GetReady />,
};

export default IntroRoutes;
